import SectionHeading from "@/components/base/SectionHeading";
import { hotRanking } from "@/mocks/spotlight";

const trendMap = {
  up: { icon: "ri-arrow-up-line", label: "热度上升", cls: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", label: "热度回落", cls: "text-secondary-600" },
  flat: { icon: "ri-subtract-line", label: "热度持平", cls: "text-foreground-400" },
} as const;

export default function HotRanking() {
  return (
    <section id="ranking" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="Hot Ranking"
              title="热议榜"
              desc="按综合讨论热度实时排序，帮你在最短时间内抓住今天最值得围观的话题。"
            />
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-2 font-label text-sm text-foreground-600">
                <span className="flex h-5 w-5 items-center justify-center text-primary-600">
                  <i className="ri-refresh-line"></i>
                </span>
                榜单每 5 分钟刷新一次
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                热度综合讨论量、评论增长速度与观点分布计算得出，仅反映话题受关注程度。
              </p>
              <a
                href="#arena"
                className="mt-4 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
              >
                去观点擂台
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="flex flex-col gap-3">
              {hotRanking.map((item) => {
                const trend = trendMap[item.trend as keyof typeof trendMap];
                const top = item.rank <= 3;
                return (
                  <li key={item.rank}>
                    <a
                      href="#arena"
                      className="flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
                    >
                      <span
                        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                          top
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-100 text-foreground-500"
                        }`}
                      >
                        {item.rank}
                      </span>
                      <span className="min-w-0 flex-1 font-label text-sm leading-snug text-foreground-900">
                        {item.title}
                      </span>
                      <span className="hidden shrink-0 items-center gap-1.5 font-label text-xs text-foreground-500 sm:flex">
                        <i className={`${trend.icon} ${trend.cls}`}></i>
                        {item.heat}
                      </span>
                    </a>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}